
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dGhsu", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");




var $9XdgS = parcelRequire("9XdgS");




var $kQRQB = parcelRequire("kQRQB");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $35oAA = parcelRequire("35oAA");

const $aaeb66d37f355457$var$BylineCenterStyles = (0, $ecnYn.xcss)({
    justifyContent: 'center'
});
const $aaeb66d37f355457$export$6ac99e13b8ebf390 = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { contentId: contentId, spaceKey: spaceKey, banner: banner, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, headingContainer: headingContainer, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, contentSubType: contentSubType, spaceId: spaceId, hasByLine: t1 } = t0;
    const hasByLine = t1 === undefined ? true : t1;
    const { versionOverride: versionOverride, embeddedContentRender: embeddedContentRender } = (0, $35oAA.useViewPageParams)();
    let t2;
    if ($[0] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t2;
    } else t2 = $[1];
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)(t2);
    const isBylineCenterStyles = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const t3 = isBylineCenterStyles && $aaeb66d37f355457$var$BylineCenterStyles;
    let t4;
    if ($[2] !== t3) {
        t4 = [
            t3
        ];
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const t5 = isBylineCenterStyles ? "centered-content-title-and-byline" : "content-title-and-byline";
    let t6;
    if ($[4] !== contentId || $[5] !== contentSubType || $[6] !== contentType || $[7] !== embeddedContentRender || $[8] !== hasByLine || $[9] !== hasByLineContributors || $[10] !== hasByLineExtensions || $[11] !== shouldShowBylineReactions || $[12] !== spaceId || $[13] !== versionOverride) {
        t6 = hasByLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9XdgS.ByLine), {
            contentId: contentId,
            versionOverride: versionOverride,
            embeddedContentRender: embeddedContentRender,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentType: contentType,
            contentSubType: contentSubType,
            spaceId: spaceId
        });
        $[4] = contentId;
        $[5] = contentSubType;
        $[6] = contentType;
        $[7] = embeddedContentRender;
        $[8] = hasByLine;
        $[9] = hasByLineContributors;
        $[10] = hasByLineExtensions;
        $[11] = shouldShowBylineReactions;
        $[12] = spaceId;
        $[13] = versionOverride;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t4,
            testId: t5
        }, t6);
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== banner || $[20] !== contentId || $[21] !== hasCoverPicture || $[22] !== headingContainer || $[23] !== isEmbeddedPage || $[24] !== pageWidthType || $[25] !== spaceKey || $[26] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kQRQB.ContentTitle), {
            banner: banner,
            contentId: contentId,
            spaceKey: spaceKey,
            headingContainer: headingContainer,
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage
        }, t7);
        $[19] = banner;
        $[20] = contentId;
        $[21] = hasCoverPicture;
        $[22] = headingContainer;
        $[23] = isEmbeddedPage;
        $[24] = pageWidthType;
        $[25] = spaceKey;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
};
module.exports["ContentTitleWithByLine"] = $aaeb66d37f355457$export$6ac99e13b8ebf390;

});

parcelRegister("cHvhT", function(module, exports) {

let $0262de052bc58c94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0262de052bc58c94$var$load("6wr18"),
    $0262de052bc58c94$var$load("bL9LM"),
    $0262de052bc58c94$var$load("ffEVr"),
    $0262de052bc58c94$var$load("gqoMB")
]).then(()=>parcelRequire('bqjR5'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("7EFA6", function(module, exports) {

let $592c8608a97e0206$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $592c8608a97e0206$var$load("22DNY").then(()=>parcelRequire('6VDyY'));

});

parcelRegister("kMgau", function(module, exports) {

let $f204d5040c3f7379$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f204d5040c3f7379$var$load("k5Ch2"),
    $f204d5040c3f7379$var$load("djob1"),
    $f204d5040c3f7379$var$load("aOQqp"),
    $f204d5040c3f7379$var$load("2YGw3"),
    $f204d5040c3f7379$var$load("4amFq"),
    $f204d5040c3f7379$var$load("6wr18"),
    $f204d5040c3f7379$var$load("Wowvf"),
    $f204d5040c3f7379$var$load("7EorR"),
    $f204d5040c3f7379$var$load("3EXzu"),
    $f204d5040c3f7379$var$load("ffEVr"),
    $f204d5040c3f7379$var$load("1C6qR")
]).then(()=>parcelRequire('kTkGJ'));

});

parcelRegister("9XdgS", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $2VQ4B = parcelRequire("2VQ4B");


var $io723 = parcelRequire("io723");


var $zalpJ = parcelRequire("zalpJ");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $gXrHX = parcelRequire("gXrHX");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $c0urc = parcelRequire("c0urc");

var $1SNEF = parcelRequire("1SNEF");


var $jMyy4 = parcelRequire("jMyy4");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");


var $hlP5l = parcelRequire("hlP5l");








var $gMc0m = parcelRequire("gMc0m");





var $jVylI = parcelRequire("jVylI");




// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d8e46f2fc87fe7$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s8t1lt _4t3i1ylp _1e0c1txw",
            __cmplp.isTitleCenterAligned ? "_1bah1h6o" : "_1bah4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$Circle = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1rr0 _bfhkizff",
            __cmplp.isTitleCenterAligned ? "_1bsb1ejb" : "_1bsbxy5q",
            __cmplp.isTitleCenterAligned ? "_4t3i1ejb" : "_4t3ixy5q",
            __cmplp.isTitleCenterAligned ? "_19pkidpf _2hwx1v6z _otyridpf _18u0idpf" : "_19pk1l7b _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$LineContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _18u0u2gc _2hwxv77o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$Line1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rkolb4i _bfhkizff _1bsb53f4 _4t3idlk8 _19pk1b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$Line2 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rkolb4i _bfhkizff _4t3i1crf _19pk1b66",
            __cmplp.isTitleCenterAligned ? "_1bsbr0r7" : "_1bsb1w81",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$FirstRowContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$export$438daec06afefb9e = ()=>{
    const $ = (0, $frIzR.c)(17);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)(t0);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    if (isTitleCenterAligned) {
        let t1;
        if ($[2] !== isTitleCenterAligned) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f1d8e46f2fc87fe7$var$Circle, {
                isTitleCenterAligned: isTitleCenterAligned
            });
            $[2] = isTitleCenterAligned;
            $[3] = t1;
        } else t1 = $[3];
        let t2;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f1d8e46f2fc87fe7$var$Line1, null);
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] !== t1) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f1d8e46f2fc87fe7$var$FirstRowContainer, null, t1, t2);
            $[5] = t1;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== isTitleCenterAligned) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f1d8e46f2fc87fe7$var$Line2, {
                isTitleCenterAligned: isTitleCenterAligned
            });
            $[7] = isTitleCenterAligned;
            $[8] = t4;
        } else t4 = $[8];
        let t5;
        if ($[9] !== t3 || $[10] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f1d8e46f2fc87fe7$var$LineContainer, null, t3, t4);
            $[9] = t3;
            $[10] = t4;
            $[11] = t5;
        } else t5 = $[11];
        let t6;
        if ($[12] !== isTitleCenterAligned || $[13] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f1d8e46f2fc87fe7$var$Container, {
                isTitleCenterAligned: isTitleCenterAligned
            }, t5);
            $[12] = isTitleCenterAligned;
            $[13] = t5;
            $[14] = t6;
        } else t6 = $[14];
        return t6;
    }
    let t1;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f1d8e46f2fc87fe7$var$Circle, null);
        $[15] = t1;
    } else t1 = $[15];
    let t2;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f1d8e46f2fc87fe7$var$Container, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f1d8e46f2fc87fe7$var$LineContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f1d8e46f2fc87fe7$var$Line1, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f1d8e46f2fc87fe7$var$Line2, null)));
        $[16] = t2;
    } else t2 = $[16];
    return t2;
};



var $83fWZ = parcelRequire("83fWZ");








var $gtD4K = parcelRequire("gtD4K");





var $2Pg7f = parcelRequire("2Pg7f");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $9wGTI = parcelRequire("9wGTI");





var $1eaCJ = parcelRequire("1eaCJ");








var $jJK3p = parcelRequire("jJK3p");


var $fs6LW = parcelRequire("fs6LW");


var $a6t12 = parcelRequire("a6t12");


var $04VgG = parcelRequire("04VgG");


var $fImWv = parcelRequire("fImWv");





var $jmjWc = parcelRequire("jmjWc");


const $c66d644eb983f72b$export$a580dab1b138f630 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Rutb",
    name: "PoweredByTemplates",
    loader: async ()=>(await (parcelRequire("cHvhT"))).PoweredByTemplates
});



var $7om8k = parcelRequire("7om8k");


var $3u0dr = parcelRequire("3u0dr");








var $3jwuS = parcelRequire("3jwuS");





var $aNtZv = parcelRequire("aNtZv");













var $8C5kA = parcelRequire("8C5kA");









var $kuujH = parcelRequire("kuujH");

const $f0e53dc7f760c1cc$export$c848e73bc0377f69 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { owner: owner, templateId: templateId, abbreviateBylineText: abbreviateBylineText, generatedBy: generatedBy } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            color: "var(--ds-text-subtle, #505258)"
        };
        $[0] = t1;
    } else t1 = $[0];
    const style = t1;
    const intl = (0, $8C5kA.default)();
    const bylineTextTemplate = abbreviateBylineText ? (0, $kuujH.i18n).abbreviatedBylineMainText : (0, $kuujH.i18n).bylineMainTextWithTemplate;
    let bylineTextNonTemplate;
    if (abbreviateBylineText) {
        if (generatedBy === "ONBOARDING") bylineTextNonTemplate = (0, $kuujH.i18n).bylineMainTextCreatedByConfluence;
        else bylineTextNonTemplate = (0, $kuujH.i18n).abbreviatedBylineMainText;
    } else if (generatedBy === "ONBOARDING") bylineTextNonTemplate = (0, $kuujH.i18n).bylineMainTextCreatedByConfluence;
    else bylineTextNonTemplate = (0, $kuujH.i18n).bylineMainText;
    let t2;
    if ($[1] !== bylineTextNonTemplate || $[2] !== bylineTextTemplate || $[3] !== intl || $[4] !== owner.fullName || $[5] !== templateId) {
        const withTemplate = intl.formatMessage((0, $kuujH.i18n).poweredByTemplates);
        t2 = templateId ? intl.formatMessage(bylineTextTemplate, {
            user: owner.fullName,
            withTemplate: withTemplate
        }) : intl.formatMessage(bylineTextNonTemplate, {
            user: owner.fullName
        });
        $[1] = bylineTextNonTemplate;
        $[2] = bylineTextTemplate;
        $[3] = intl;
        $[4] = owner.fullName;
        $[5] = templateId;
        $[6] = t2;
    } else t2 = $[6];
    const ownerLabel = t2;
    let t3;
    if ($[7] !== owner.fullName || $[8] !== owner.isAnonymous || $[9] !== owner.userId || $[10] !== ownerLabel) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
            userId: owner.userId,
            fullName: owner.fullName,
            isAnonymous: owner.isAnonymous,
            referralSource: "profilecard",
            style: style,
            ariaLabel: ownerLabel
        });
        $[7] = owner.fullName;
        $[8] = owner.isAnonymous;
        $[9] = owner.userId;
        $[10] = ownerLabel;
        $[11] = t3;
    } else t3 = $[11];
    const linkOnly = t3;
    let t4;
    if ($[12] !== linkOnly || $[13] !== owner.userId || $[14] !== ownerLabel) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: owner.userId,
            ariaLabel: ownerLabel
        }, linkOnly);
        $[12] = linkOnly;
        $[13] = owner.userId;
        $[14] = ownerLabel;
        $[15] = t4;
    } else t4 = $[15];
    const profileLink = t4;
    let t5;
    if ($[16] !== bylineTextNonTemplate || $[17] !== bylineTextTemplate || $[18] !== profileLink || $[19] !== templateId) {
        t5 = templateId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...bylineTextTemplate,
            values: {
                user: profileLink,
                withTemplate: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c66d644eb983f72b$export$a580dab1b138f630), {
                    templateId: templateId
                })
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...bylineTextNonTemplate,
            values: {
                user: profileLink
            }
        });
        $[16] = bylineTextNonTemplate;
        $[17] = bylineTextTemplate;
        $[18] = profileLink;
        $[19] = templateId;
        $[20] = t5;
    } else t5 = $[20];
    return t5;
} : ({ owner: owner, templateId: templateId, abbreviateBylineText: abbreviateBylineText, generatedBy: generatedBy })=>{
    const style = {
        color: "var(--ds-text-subtle, #505258)"
    };
    const intl = (0, $8C5kA.default)();
    const bylineTextTemplate = abbreviateBylineText ? (0, $kuujH.i18n).abbreviatedBylineMainText : (0, $kuujH.i18n).bylineMainTextWithTemplate;
    let bylineTextNonTemplate;
    if (abbreviateBylineText) {
        if (generatedBy === 'ONBOARDING') bylineTextNonTemplate = (0, $kuujH.i18n).bylineMainTextCreatedByConfluence;
        else bylineTextNonTemplate = (0, $kuujH.i18n).abbreviatedBylineMainText;
    } else if (generatedBy === 'ONBOARDING') bylineTextNonTemplate = (0, $kuujH.i18n).bylineMainTextCreatedByConfluence;
    else bylineTextNonTemplate = (0, $kuujH.i18n).bylineMainText;
    const withTemplate = intl.formatMessage((0, $kuujH.i18n).poweredByTemplates);
    const ownerLabel = templateId ? intl.formatMessage(bylineTextTemplate, {
        user: owner.fullName,
        withTemplate: withTemplate
    }) : intl.formatMessage(bylineTextNonTemplate, {
        user: owner.fullName
    });
    const linkOnly = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
        userId: owner.userId,
        fullName: owner.fullName,
        isAnonymous: owner.isAnonymous,
        referralSource: "profilecard",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ariaLabel: ownerLabel
    });
    const profileLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: owner.userId,
        ariaLabel: ownerLabel
    }, linkOnly);
    return templateId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...bylineTextTemplate,
        values: {
            user: profileLink,
            withTemplate: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c66d644eb983f72b$export$a580dab1b138f630), {
                templateId: templateId
            })
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...bylineTextNonTemplate,
        values: {
            user: profileLink
        }
    });
};















var $9VJDA = parcelRequire("9VJDA");


var $lGgRw = parcelRequire("lGgRw");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");





























var $68BwE = parcelRequire("68BwE");


var $jFm04 = parcelRequire("jFm04");








var $3SLf9 = parcelRequire("3SLf9");


var $jgcNz = parcelRequire("jgcNz");

const $3917d8ab4709c9cb$export$5cddb5ddc3554ec9 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { ownedByAccountId: ownedByAccountId, onClosePopup: onClosePopup, creator: creator, createdDate: createdDate, contentId: contentId, lastOwner: lastOwner } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const { openModal: openModal } = (0, $jFm04.useContentOwnershipContext)();
    const showChangeOwnerAction = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedByAccountId);
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { isArchived: isArchived } = (0, $jgcNz.useContentInfo)(t1);
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    let t2;
    if ($[2] !== contentId || $[3] !== createAnalyticsEvent || $[4] !== experienceTracker || $[5] !== onClosePopup || $[6] !== openModal) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "change.page.owner.button",
                    source: "viewPageScreen",
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
            experienceTracker.start({
                name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
            });
            onClosePopup();
            openModal();
        };
        $[2] = contentId;
        $[3] = createAnalyticsEvent;
        $[4] = experienceTracker;
        $[5] = onClosePopup;
        $[6] = openModal;
        $[7] = t2;
    } else t2 = $[7];
    const handleClick = t2;
    let t3;
    if ($[8] !== createdDate || $[9] !== creator.fullName || $[10] !== intl) {
        const dateOptions = {
            month: "short",
            day: "2-digit",
            year: "numeric"
        };
        t3 = createdDate ? intl.formatMessage((0, $kuujH.i18n).popupCreatedBy, {
            user: creator.fullName,
            date: createdDate?.toLocaleDateString(intl.locale, dateOptions),
            b: $3917d8ab4709c9cb$var$_temp
        }) : intl.formatMessage((0, $kuujH.i18n).popupCreatedByUnknownDate, {
            user: creator.fullName,
            b: $3917d8ab4709c9cb$var$_temp2
        });
        $[8] = createdDate;
        $[9] = creator.fullName;
        $[10] = intl;
        $[11] = t3;
    } else t3 = $[11];
    const createdByContent = t3;
    let t4;
    if ($[12] !== intl || $[13] !== lastOwner) {
        t4 = lastOwner ? intl.formatMessage((0, $kuujH.i18n).popupLastOwnedBy, {
            user: lastOwner?.fullName,
            b: $3917d8ab4709c9cb$var$_temp3
        }) : null;
        $[12] = intl;
        $[13] = lastOwner;
        $[14] = t4;
    } else t4 = $[14];
    const lastOwnedByContent = t4;
    let t5;
    if ($[15] !== lastOwnedByContent) {
        t5 = lastOwnedByContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.PopupUserDetailsContainer), null, lastOwnedByContent);
        $[15] = lastOwnedByContent;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== createdByContent) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.PopupUserDetailsContainer), null, createdByContent);
        $[17] = createdByContent;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== handleClick || $[20] !== intl || $[21] !== isArchived || $[22] !== showChangeOwnerAction) {
        t7 = showChangeOwnerAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.PopupButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            testId: "page-owner-popup-change-owner-button",
            appearance: "primary",
            onClick: handleClick,
            isDisabled: isArchived
        }, intl.formatMessage((0, $kuujH.i18n).popupChangeOwnerButton)));
        $[19] = handleClick;
        $[20] = intl;
        $[21] = isArchived;
        $[22] = showChangeOwnerAction;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== t5 || $[25] !== t6 || $[26] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.PopupContainer), {
            "data-testid": "page-ownership-popup-container"
        }, t5, t6, t7);
        $[24] = t5;
        $[25] = t6;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : ({ ownedByAccountId: ownedByAccountId, onClosePopup: onClosePopup, creator: creator, createdDate: createdDate, contentId: contentId, lastOwner: lastOwner })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const { openModal: openModal } = (0, $jFm04.useContentOwnershipContext)();
    const showChangeOwnerAction = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedByAccountId);
    const { isArchived: isArchived } = (0, $jgcNz.useContentInfo)({
        contentId: contentId
    });
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'change.page.owner.button',
                source: 'viewPageScreen',
                attributes: {
                    contentId: contentId
                }
            }
        }).fire();
        experienceTracker.start({
            name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
        });
        onClosePopup();
        openModal();
    }, [
        onClosePopup,
        openModal,
        createAnalyticsEvent,
        contentId,
        experienceTracker
    ]);
    const dateOptions = {
        month: 'short',
        day: '2-digit',
        year: 'numeric'
    };
    const createdByContent = createdDate ? intl.formatMessage((0, $kuujH.i18n).popupCreatedBy, {
        user: creator.fullName,
        date: createdDate?.toLocaleDateString(intl.locale, dateOptions),
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
    }) : // In practice, this shouldn't happen
    intl.formatMessage((0, $kuujH.i18n).popupCreatedByUnknownDate, {
        user: creator.fullName,
        b: (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks_0)
    });
    const lastOwnedByContent = lastOwner ? intl.formatMessage((0, $kuujH.i18n).popupLastOwnedBy, {
        user: lastOwner?.fullName,
        b: (chunks_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks_1)
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.PopupContainer), {
        "data-testid": "page-ownership-popup-container"
    }, lastOwnedByContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.PopupUserDetailsContainer), null, lastOwnedByContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.PopupUserDetailsContainer), null, createdByContent), showChangeOwnerAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.PopupButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "page-owner-popup-change-owner-button",
        appearance: "primary",
        onClick: handleClick,
        isDisabled: isArchived
    }, intl.formatMessage((0, $kuujH.i18n).popupChangeOwnerButton))));
};
function $3917d8ab4709c9cb$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks);
}
function $3917d8ab4709c9cb$var$_temp2(chunks_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks_0);
}
function $3917d8ab4709c9cb$var$_temp3(chunks_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks_1);
}





const $36bccc39427fd9ff$export$ab5e7530673baa4e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { ownedByAccountId: ownedByAccountId, creator: creator, createdDate: createdDate, contentId: contentId, lastOwner: lastOwner } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const canChangeOwner = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedByAccountId);
    const intl = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent) {
        t1 = ()=>{
            setIsOpen(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "byline.menu.icon",
                    source: "viewPageScreen",
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    const openPopup = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsOpen(false);
        $[3] = t2;
    } else t2 = $[3];
    const closePopup = t2;
    let t3;
    if ($[4] !== isOpen || $[5] !== openPopup) {
        t3 = ()=>!isOpen ? openPopup() : closePopup();
        $[4] = isOpen;
        $[5] = openPopup;
        $[6] = t3;
    } else t3 = $[6];
    const handleClickPopupTrigger = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            closePopup();
        };
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== contentId) {
        t5 = [
            closePopup,
            contentId
        ];
        $[8] = contentId;
        $[9] = t5;
    } else t5 = $[9];
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[10] !== canChangeOwner || $[11] !== intl) {
        t6 = canChangeOwner ? intl.formatMessage((0, $kuujH.i18n).bylineButtonTooltip) : intl.formatMessage((0, $kuujH.i18n).bylineButtonTooltipReadOnly);
        $[10] = canChangeOwner;
        $[11] = intl;
        $[12] = t6;
    } else t6 = $[12];
    const tooltipContent = t6;
    let t7;
    if ($[13] !== contentId || $[14] !== createdDate || $[15] !== creator || $[16] !== lastOwner || $[17] !== ownedByAccountId) {
        t7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3917d8ab4709c9cb$export$5cddb5ddc3554ec9), {
                ownedByAccountId: ownedByAccountId,
                onClosePopup: closePopup,
                creator: creator,
                createdDate: createdDate,
                contentId: contentId,
                lastOwner: lastOwner
            });
        $[13] = contentId;
        $[14] = createdDate;
        $[15] = creator;
        $[16] = lastOwner;
        $[17] = ownedByAccountId;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== handleClickPopupTrigger || $[20] !== intl || $[21] !== isOpen || $[22] !== tooltipContent) {
        t8 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                hideTooltipOnClick: true,
                content: tooltipContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                testId: "page-owner-byline-popup-trigger",
                spacing: "compact",
                appearance: "subtle",
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                    label: intl.formatMessage((0, $kuujH.i18n).popupTriggerLabel),
                    color: "var(--ds-text-subtle, #505258)"
                }),
                ...triggerProps,
                onClick: handleClickPopupTrigger
            }));
        $[19] = handleClickPopupTrigger;
        $[20] = intl;
        $[21] = isOpen;
        $[22] = tooltipContent;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== isOpen || $[25] !== t7 || $[26] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            placement: "bottom",
            isOpen: isOpen,
            onClose: closePopup,
            content: t7,
            trigger: t8,
            shouldRenderToParent: true
        });
        $[24] = isOpen;
        $[25] = t7;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
} : ({ ownedByAccountId: ownedByAccountId, creator: creator, createdDate: createdDate, contentId: contentId, lastOwner: lastOwner })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const canChangeOwner = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedByAccountId);
    const intl = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const openPopup = (0, $42omo.useCallback)(()=>{
        setIsOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'byline.menu.icon',
                source: 'viewPageScreen',
                attributes: {
                    contentId: contentId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId
    ]);
    const closePopup = (0, $42omo.useCallback)(()=>setIsOpen(false), []);
    const handleClickPopupTrigger = (0, $42omo.useCallback)(()=>!isOpen ? openPopup() : closePopup(), [
        isOpen,
        openPopup,
        closePopup
    ]);
    (0, $42omo.useEffect)(()=>{
        // If the content ID changes, it means the user switched pages.
        // For some reason, the popup doesn't close automatically, so
        // we need to manually close it.
        closePopup();
    }, [
        closePopup,
        contentId
    ]);
    const tooltipContent = canChangeOwner ? intl.formatMessage((0, $kuujH.i18n).bylineButtonTooltip) : intl.formatMessage((0, $kuujH.i18n).bylineButtonTooltipReadOnly);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        placement: "bottom",
        isOpen: isOpen,
        onClose: closePopup,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3917d8ab4709c9cb$export$5cddb5ddc3554ec9), {
                ownedByAccountId: ownedByAccountId,
                onClosePopup: closePopup,
                creator: creator,
                createdDate: createdDate,
                contentId: contentId,
                lastOwner: lastOwner
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                hideTooltipOnClick: true,
                content: tooltipContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                testId: "page-owner-byline-popup-trigger",
                spacing: "compact",
                appearance: "subtle",
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                    label: intl.formatMessage((0, $kuujH.i18n).popupTriggerLabel),
                    color: "var(--ds-text-subtle, #505258)"
                }),
                ...triggerProps,
                onClick: handleClickPopupTrigger
            })),
        shouldRenderToParent: true
    });
};


const $3e1c24b20a2bb195$export$6abd4474c72537a = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { owner: owner, creator: creator, createdDate: createdDate, templateId: templateId, contentId: contentId, lastOwner: lastOwner, generatedBy: generatedBy } = t0;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let t1;
    if ($[0] !== isLivePage) {
        t1 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline");
        $[0] = isLivePage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== generatedBy || $[3] !== owner || $[4] !== t1 || $[5] !== templateId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.BylineMessageContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f0e53dc7f760c1cc$export$c848e73bc0377f69), {
            owner: owner,
            templateId: templateId,
            abbreviateBylineText: t1,
            generatedBy: generatedBy
        }));
        $[2] = generatedBy;
        $[3] = owner;
        $[4] = t1;
        $[5] = templateId;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== contentId || $[8] !== createdDate || $[9] !== creator || $[10] !== isLivePage || $[11] !== lastOwner || $[12] !== owner) {
        t3 = !isLivePage && !(0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $36bccc39427fd9ff$export$ab5e7530673baa4e), {
            creator: creator,
            createdDate: createdDate,
            ownedByAccountId: owner.userId,
            contentId: contentId,
            lastOwner: lastOwner
        });
        $[7] = contentId;
        $[8] = createdDate;
        $[9] = creator;
        $[10] = isLivePage;
        $[11] = lastOwner;
        $[12] = owner;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== t2 || $[15] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.BylineContainer), null, t2, t3);
        $[14] = t2;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ owner: owner, creator: creator, createdDate: createdDate, templateId: templateId, contentId: contentId, lastOwner: lastOwner, generatedBy: generatedBy })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.BylineContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.BylineMessageContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f0e53dc7f760c1cc$export$c848e73bc0377f69), {
        owner: owner,
        templateId: templateId,
        abbreviateBylineText: isLivePage || (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline'),
        generatedBy: generatedBy
    })), !isLivePage && !(0, $9wGTI.fg)('cc_page_experiences_new_editor_byline') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $36bccc39427fd9ff$export$ab5e7530673baa4e), {
        creator: creator,
        createdDate: createdDate,
        ownedByAccountId: owner.userId,
        contentId: contentId,
        lastOwner: lastOwner
    }));
};






const $b3f1a98366675b36$export$bffecd160d81d78c = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "yzXpt",
    loader: async ()=>(await (parcelRequire("7EFA6"))).AutoConversionByLine,
    name: 'AutoConversionByLine'
});






var $63EIj = parcelRequire("63EIj");








var $iHQDd = parcelRequire("iHQDd");


var $cgtv4 = parcelRequire("cgtv4");






var $bUlM5 = parcelRequire("bUlM5");




var $4FHTF = parcelRequire("4FHTF");





var $hSqtY = parcelRequire("hSqtY");


var $isEtk = parcelRequire("isEtk");


var $bQm3c = parcelRequire("bQm3c");




/**
 * @generated SignedSource<<ed620a8da1457ce1e1918bd20c68212b>>
 * @relayHash 2103c53d735f991e490d064c47f4e477
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be855f802987ae713ce771a2def749f914ce00b7a493b56b29d8bc0d4b823c39
const $39b308dfbd9fe211$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endTime"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startTime"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountIds",
                    "variableName": "accountIds"
                },
                {
                    "kind": "Variable",
                    "name": "contentIds",
                    "variableName": "contentIds"
                },
                {
                    "kind": "Variable",
                    "name": "endTime",
                    "variableName": "endTime"
                },
                {
                    "kind": "Variable",
                    "name": "startTime",
                    "variableName": "startTime"
                }
            ],
            "concreteType": "ContentAnalyticsLastViewedAtByPage",
            "kind": "LinkedField",
            "name": "contentAnalyticsLastViewedAtByPage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentAnalyticsLastViewedAtByPageItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastViewedAt"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "2103c53d735f991e490d064c47f4e477",
            "id": "be855f802987ae713ce771a2def749f914ce00b7a493b56b29d8bc0d4b823c39",
            "metadata": {},
            "name": "useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery",
            "operationKind": "query",
            "text": "query useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery($contentIds:[ID!]!,$startTime:String!,$endTime:String,$accountIds:[ID!]){contentAnalyticsLastViewedAtByPage(contentIds:$contentIds,startTime:$startTime,endTime:$endTime,accountIds:$accountIds){nodes{contentId,lastViewedAt}}}"
        }
    };
}();
$39b308dfbd9fe211$var$node.hash = "38710c79bd60dde8a74c9adbe1cc64cc";
var $39b308dfbd9fe211$export$2e2bcd8739ae039 = $39b308dfbd9fe211$var$node;


/**
 * @generated SignedSource<<52221207e921c6ab425a2ee6dee40278>>
 * @relayHash 6ba4246d568f662506bcf5f862b52c70
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 307eae256f3e7eed97f541ec200ad12843f4e5a3262b4a2a5f5aa7176285b303
const $2e8acd0a701661bd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "startTime"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "eventName",
                    "value": [
                        "reaction_created"
                    ]
                },
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 1
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Variable",
                    "name": "startTime",
                    "variableName": "startTime"
                }
            ],
            "concreteType": "CountGroupByPage",
            "kind": "LinkedField",
            "name": "countGroupByPage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CountGroupByPageItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "count"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "page"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "6ba4246d568f662506bcf5f862b52c70",
            "id": "307eae256f3e7eed97f541ec200ad12843f4e5a3262b4a2a5f5aa7176285b303",
            "metadata": {},
            "name": "useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery",
            "operationKind": "query",
            "text": "query useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery($pageId:[ID!]!,$startTime:String!){countGroupByPage(pageId:$pageId,startTime:$startTime,eventName:[reaction_created],limit:1){nodes{count,page}}}"
        }
    };
}();
$2e8acd0a701661bd$var$node.hash = "e0f215e969dd8fe8e354bb8df118ce2f";
var $2e8acd0a701661bd$export$2e2bcd8739ae039 = $2e8acd0a701661bd$var$node;











const $7910f877b0049356$var$countReactionsByTime = (0, $2e8acd0a701661bd$export$2e2bcd8739ae039);
const $7910f877b0049356$var$getUserLastViewed = (0, $39b308dfbd9fe211$export$2e2bcd8739ae039);
const $7910f877b0049356$export$5652ebafb48694f = ({ contentId: contentId, isContributor: isContributor, skip: skip = false })=>{
    const thirtyDaysAgo = (0, $42omo.useMemo)(()=>{
        const date = new Date();
        date.setDate(date.getDate() - 30);
        return date.toISOString();
    }, []);
    // To prevent counting the current visit
    const fiveSecondsAgo = (0, $42omo.useMemo)(()=>{
        const date = new Date();
        date.setSeconds(date.getSeconds() - 5);
        return date.toISOString();
    }, []);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const shouldRunUserLastViewedQuery = isContributor && !skip && userId;
    const { data: userLastViewedData, loading: userLastViewedLoading, error: userLastViewedError } = (0, $jMyy4.useQueryInterop)($7910f877b0049356$var$getUserLastViewed, {
        variables: {
            contentIds: [
                contentId
            ],
            startTime: thirtyDaysAgo,
            endTime: fiveSecondsAgo,
            accountIds: userId ? [
                userId
            ] : []
        },
        skip: !shouldRunUserLastViewedQuery
    });
    const lastViewedAt = (0, $42omo.useMemo)(()=>{
        return userLastViewedData?.contentAnalyticsLastViewedAtByPage?.nodes?.[0]?.lastViewedAt;
    }, [
        userLastViewedData
    ]);
    const shouldRunReactionCountQuery = Boolean(shouldRunUserLastViewedQuery && !userLastViewedLoading && !userLastViewedError && lastViewedAt);
    const { data: countReactionByTimeData, loading: countReactionByTimeLoading, error: countReactionByTimeError } = (0, $jMyy4.useQueryInterop)($7910f877b0049356$var$countReactionsByTime, {
        variables: {
            pageId: [
                contentId
            ],
            startTime: lastViewedAt || ''
        },
        skip: !shouldRunReactionCountQuery
    });
    const isLoading = countReactionByTimeLoading || userLastViewedLoading;
    const allErrors = countReactionByTimeError || userLastViewedError;
    const isEligible = (0, $42omo.useMemo)(()=>{
        if (skip || !isContributor) return false;
        if (isLoading || allErrors) return false;
        if (!lastViewedAt) return false;
        const reactionCount = countReactionByTimeData?.countGroupByPage?.nodes?.[0]?.count || 0;
        return reactionCount > 0;
    }, [
        countReactionByTimeData,
        skip,
        isContributor,
        isLoading,
        allErrors,
        lastViewedAt
    ]);
    return {
        isEligible: isEligible,
        loading: isLoading,
        error: allErrors
    };
};



var $5Kc7f = parcelRequire("5Kc7f");











var $bFPHx = parcelRequire("bFPHx");


const $7b10285448e39671$export$818988cb4f30ec46 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vP7ts",
    name: "ReactionsSSRLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("kMgau"))).Reactions
});



var $1NF8X = parcelRequire("1NF8X");


var $3FlVr = parcelRequire("3FlVr");


var $ke5Nx = parcelRequire("ke5Nx");


var $6mKj3 = parcelRequire("6mKj3");

const $7bbeff754c7e0bdb$var$i18n = (0, $cgtv4.defineMessages)({
    addNew: {
        id: "reactions.view-page.byline.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "reactions.view-page.byline.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $7bbeff754c7e0bdb$var$ViewPageReactionsContainerCommonStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    clear: 'both',
    overflow: 'visible',
    maxWidth: 'unset',
    margin: 'unset',
    marginBottom: 'space.025',
    marginTop: 'space.025',
    height: '28px'
});
const $7bbeff754c7e0bdb$var$dotStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-050, 4px)",
    width: "var(--ds-space-050, 4px)",
    backgroundColor: 'color.background.brand.bold',
    borderRadius: 'radius.full',
    alignSelf: 'center',
    transition: 'opacity 300ms ease-in-out'
});
const $7bbeff754c7e0bdb$var$ReactionsComponent = (t0)=>{
    const $ = (0, $frIzR.c)(33);
    const { contentId: contentId, contentType: contentType, spaceId: spaceId, contentSubType: contentSubType, noFlexWrap: noFlexWrap, noRelativeContainer: noRelativeContainer, bylineContainerRef: t1, isCurrentUserContributor: isCurrentUserContributor } = t0;
    const bylineContainerRef = t1 === undefined ? undefined : t1;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [state] = (0, $isEtk.useContentState)();
    const { focusedPageReactionsId: focusedPageReactionsId } = (0, $ke5Nx.useReactionsQueryParams)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            rootMargin: "-100px 0px 0px 0px",
            triggerOnce: true
        };
        $[0] = t2;
    } else t2 = $[0];
    const [reactionsRef, reactionsSectionInView] = (0, $iHQDd.useInView)(t2);
    const t3 = Boolean(isCurrentUserContributor);
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $9wGTI.fg)("cc-engagement-reactions-feedback-page-return-kill");
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== contentId || $[3] !== t3) {
        t5 = {
            contentId: contentId,
            isContributor: t3,
            skip: !t4
        };
        $[2] = contentId;
        $[3] = t3;
        $[4] = t5;
    } else t5 = $[4];
    const { isEligible: isEligibleReactionsFeedbackPageReturn, loading: isLoadingReactionsFeedbackPageReturn } = (0, $7910f877b0049356$export$5652ebafb48694f)(t5);
    !isLoadingReactionsFeedbackPageReturn && isEligibleReactionsFeedbackPageReturn && (0, $6mKj3.expValEquals)("cc_engagement_reactions_feedback_page_return_aa", "cohort", "control");
    let t6;
    if ($[5] !== isEligibleReactionsFeedbackPageReturn || $[6] !== isLoadingReactionsFeedbackPageReturn) {
        t6 = !isLoadingReactionsFeedbackPageReturn && isEligibleReactionsFeedbackPageReturn && (0, $6mKj3.expValEquals)("cc-engagement-reactions-feedback-page-return-exp", "cohort", "experiment");
        $[5] = isEligibleReactionsFeedbackPageReturn;
        $[6] = isLoadingReactionsFeedbackPageReturn;
        $[7] = t6;
    } else t6 = $[7];
    const showReactionsFeedbackPageReturnExp = t6;
    let t7;
    if ($[8] !== formatMessage) {
        t7 = formatMessage($7bbeff754c7e0bdb$var$i18n.addReaction);
        $[8] = formatMessage;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))), {
            testId: "emoji-add-icon",
            color: "var(--ds-icon-subtle, #505258)",
            label: t7
        });
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    const customIcon = t8;
    let t9;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = Boolean(window.__SSR_RENDERED__) && (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
        $[12] = t9;
    } else t9 = $[12];
    const isSSR = t9;
    const isInViewAndNotOnServer = reactionsSectionInView && state?.isContentReady;
    let t10;
    if ($[13] !== bylineContainerRef || $[14] !== contentId || $[15] !== contentSubType || $[16] !== contentType || $[17] !== customIcon || $[18] !== edition || $[19] !== focusedPageReactionsId || $[20] !== formatMessage || $[21] !== noFlexWrap || $[22] !== noRelativeContainer || $[23] !== showReactionsFeedbackPageReturnExp || $[24] !== spaceId) {
        t10 = ()=>{
            if (contentType && spaceId) {
                const ReactionsLoader = Boolean(focusedPageReactionsId) ? (0, $1NF8X.ReactionsLoaderBackground) : (0, $7b10285448e39671$export$818988cb4f30ec46);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                    testId: "view-page-byline-reactions-wrapper",
                    "data-vc": "view-page-byline-reactions-wrapper"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ReactionsLoader, {
                    contentId: contentId,
                    location: contentType,
                    containerId: spaceId,
                    containerType: (0, $3FlVr.ReactionContainerType).SPACE,
                    contentSubType: contentSubType,
                    summaryViewEnabled: true,
                    summaryViewThreshold: 1,
                    allowSelectFromSummaryView: true,
                    useButtonAlignmentStyling: true,
                    summaryViewPlacement: "bottom-start",
                    animateNoReactionsText: true,
                    customAnalyticsAttributes: {
                        edition: edition
                    },
                    isSubtle: true,
                    reactionPickerTriggerIcon: customIcon,
                    useDefaultStyledContainer: true,
                    noFlexWrap: noFlexWrap,
                    noRelativeContainer: noRelativeContainer,
                    reactionPickerTriggerText: formatMessage($7bbeff754c7e0bdb$var$i18n.addNew),
                    hoverableSummaryView: true,
                    optimisticallyLoadSummaryEmojis: isSSR,
                    renderParticleEffectOnSummaryView: true,
                    bylineContainerRef: bylineContainerRef,
                    renderParticleEffectOnLoad: showReactionsFeedbackPageReturnExp
                }), showReactionsFeedbackPageReturnExp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $7bbeff754c7e0bdb$var$dotStyles,
                    testId: "reactions-feedback-experiment-dot"
                }));
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null);
        };
        $[13] = bylineContainerRef;
        $[14] = contentId;
        $[15] = contentSubType;
        $[16] = contentType;
        $[17] = customIcon;
        $[18] = edition;
        $[19] = focusedPageReactionsId;
        $[20] = formatMessage;
        $[21] = noFlexWrap;
        $[22] = noRelativeContainer;
        $[23] = showReactionsFeedbackPageReturnExp;
        $[24] = spaceId;
        $[25] = t10;
    } else t10 = $[25];
    const displayReactions = t10;
    let t11;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = [
            $7bbeff754c7e0bdb$var$ViewPageReactionsContainerCommonStyles
        ];
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== displayReactions || $[28] !== isInViewAndNotOnServer) {
        t12 = isSSR || isInViewAndNotOnServer ? displayReactions() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null);
        $[27] = displayReactions;
        $[28] = isInViewAndNotOnServer;
        $[29] = t12;
    } else t12 = $[29];
    let t13;
    if ($[30] !== reactionsRef || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            ref: reactionsRef,
            testId: "view-page-byline-reactions",
            xcss: t11
        }, t12);
        $[30] = reactionsRef;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
};
const $7bbeff754c7e0bdb$export$c52ae103b3391553 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NOTIFICATIONS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7bbeff754c7e0bdb$var$ReactionsComponent, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};






var $a9SX7 = parcelRequire("a9SX7");






















var $7Ndnw = parcelRequire("7Ndnw");


var $dizL5 = parcelRequire("dizL5");





var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $80koo = parcelRequire("80koo");


var $aE48M = parcelRequire("aE48M");










// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49dc4666e897c9b9$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _2hwx12x7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $49dc4666e897c9b9$var$Circle = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1rr0 _bfhkizff _1bsb1l7b _4t3i1l7b _1e0c1o8l _2hwx12x7 _18u012x7 _s7n4nkob",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $49dc4666e897c9b9$var$Line = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rkolb4i _bfhkizff _1bsb3okq _4t3iftgi _1e0c1o8l",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $49dc4666e897c9b9$export$5a429789f273dfa7 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { showLivePagesExtensionPoints: showLivePagesExtensionPoints } = t0;
    let t1;
    if ($[0] !== showLivePagesExtensionPoints) {
        t1 = !showLivePagesExtensionPoints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($49dc4666e897c9b9$var$Circle, {
            "data-testid": "circle-placeholder"
        });
        $[0] = showLivePagesExtensionPoints;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($49dc4666e897c9b9$var$Line, null);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($49dc4666e897c9b9$var$Container, {
            "data-testid": "byline-apps-loading"
        }, t1, t2);
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};


const $8e28168c9ada36e1$export$2902d9bfb1a677be = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { contentId: contentId, showLivePagesExtensionPoints: showLivePagesExtensionPoints } = t0;
    const [showLoader, setShowLoader] = (0, $42omo.useState)(true);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setShowLoader(false);
        $[0] = t1;
    } else t1 = $[0];
    const onLoad = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
        });
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== showLivePagesExtensionPoints || $[3] !== showLoader) {
        t3 = showLoader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $49dc4666e897c9b9$export$5a429789f273dfa7), {
            key: "byline-apps-loading",
            showLivePagesExtensionPoints: showLivePagesExtensionPoints
        }) : null;
        $[2] = showLivePagesExtensionPoints;
        $[3] = showLoader;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== contentId || $[6] !== showLivePagesExtensionPoints) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $80koo.RequireLegacyWRM), {
            key: "byline-app-wrm",
            wrm: "wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-content-byline-resources-v5"
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
                tagName: "span",
                contentId: contentId,
                location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE),
                renderWhenLoading: true
            }, (t5)=>{
                const { webItems: connectItems, loading: loadingConnectApps } = t5;
                if (loadingConnectApps) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
                    key: contentId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE),
                    render: (forgeItems, loadingForgeApps, error)=>{
                        if (loadingForgeApps) return null;
                        if (error) {
                            if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                                error: error
                            });
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                                name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
                            });
                        }
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aE48M.ByLineAppsComponent), {
                            contentId: contentId,
                            forgeItems: forgeItems,
                            connectItems: connectItems,
                            onLoad: onLoad,
                            showLivePagesExtensionPoints: showLivePagesExtensionPoints
                        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                            name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
                        }));
                    }
                });
            }));
        $[5] = contentId;
        $[6] = showLivePagesExtensionPoints;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t2, t3, t4);
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
};





















var $iXCQx = parcelRequire("iXCQx");


var $jlIaF = parcelRequire("jlIaF");





var $8lYIw = parcelRequire("8lYIw");

const $ab650b242e9af49c$var$StyledVersionComment = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _18u012x7 _80om73ad _1n6q1c8u _tw171r31 _135cglyw _1p5wnqa1 _1kt91mp2 _cfu11o8l _is06azsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ab650b242e9af49c$var$StyledLastModified = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _299m1dk0",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ab650b242e9af49c$export$ec2ac95332ccc886 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { version: version, author: author, contentId: contentId, versionComment: versionComment } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let lastUpdatedLine;
    if (version.number === 1 || version.contentTypeModified) {
        let t1;
        if ($[0] !== version.friendlyWhen) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtle",
                id: "content-header.by-line.last.updated.version.1"
            }, version.friendlyWhen);
            $[0] = version.friendlyWhen;
            $[1] = t1;
        } else t1 = $[1];
        lastUpdatedLine = t1;
    } else {
        const modifiedByAuthor = !author.isAnonymous && author.userId === version.by.userId;
        const currentVersion = version.number;
        const prevVersion = currentVersion - 1;
        const query = `pageId=${contentId}&selectedPageVersions=${prevVersion}&selectedPageVersions=${currentVersion}`;
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                color: "var(--ds-text-subtle, #505258)"
            };
            $[2] = t1;
        } else t1 = $[2];
        const style = t1;
        const t2 = `${(0, $jlIaF.CONTEXT_PATH)}/pages/diffpagesbyversion.action?${query}`;
        let t3;
        if ($[3] !== t2 || $[4] !== version.friendlyWhen) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
                style: style,
                href: t2
            }, version.friendlyWhen);
            $[3] = t2;
            $[4] = version.friendlyWhen;
            $[5] = t3;
        } else t3 = $[5];
        const changeLink = t3;
        let t4;
        if ($[6] !== changeLink || $[7] !== modifiedByAuthor || $[8] !== version.by) {
            t4 = modifiedByAuthor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "content-header.by-line.last.updated.self.expanded",
                defaultMessage: "Last updated: {date}",
                values: {
                    date: changeLink
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "content-header.by-line.last.updated.expanded",
                defaultMessage: "Last updated: {date} by {contributor}",
                values: {
                    date: changeLink,
                    contributor: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
                        userId: version.by.userId,
                        fullName: version.by.fullName,
                        isAnonymous: version.by.isAnonymous,
                        referralSource: "profilecard"
                    })
                }
            });
            $[6] = changeLink;
            $[7] = modifiedByAuthor;
            $[8] = version.by;
            $[9] = t4;
        } else t4 = $[9];
        lastUpdatedLine = t4;
        if (versionComment) {
            let t5;
            if ($[10] !== createAnalyticsEvent) {
                t5 = ()=>{
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            source: "page",
                            action: "displayed",
                            actionSubject: "tooltip",
                            actionSubjectId: "publishComment"
                        }
                    }).fire();
                };
                $[10] = createAnalyticsEvent;
                $[11] = t5;
            } else t5 = $[11];
            const fireTooltipEvent = t5;
            let t6;
            if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab650b242e9af49c$var$StyledVersionComment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    id: "content-header.by-line.last.updated.version.comment.indicator",
                    defaultMessage: "Version comment"
                }));
                $[12] = t6;
            } else t6 = $[12];
            let t7;
            if ($[13] !== fireTooltipEvent || $[14] !== versionComment) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    tag: "span",
                    content: versionComment,
                    onShow: fireTooltipEvent
                }, t6);
                $[13] = fireTooltipEvent;
                $[14] = versionComment;
                $[15] = t7;
            } else t7 = $[15];
            let t8;
            if ($[16] !== lastUpdatedLine || $[17] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, lastUpdatedLine, t7);
                $[16] = lastUpdatedLine;
                $[17] = t7;
                $[18] = t8;
            } else t8 = $[18];
            lastUpdatedLine = t8;
        }
    }
    let t1;
    if ($[19] !== lastUpdatedLine) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab650b242e9af49c$var$StyledLastModified, {
            "data-testid": "page-last-modified",
            suppressHydrationWarning: true
        }, lastUpdatedLine);
        $[19] = lastUpdatedLine;
        $[20] = t1;
    } else t1 = $[20];
    return t1;
});





// A 1x1 png with a #dfe1e6 (colors.N40) pixel
const $af34c07ddecde08d$export$1ee11f8c529fc453 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mO8//DZfwAI9AOnL5rQ+AAAAABJRU5ErkJggg==';



var $6iOCg = parcelRequire("6iOCg");


var $35Exc = parcelRequire("35Exc");


var $AavAW = parcelRequire("AavAW");


var $aKxcs = parcelRequire("aKxcs");

const $22b7bc4596013b99$var$NO_OF_AVATARS = 4;
const $22b7bc4596013b99$var$BLOG_POST_SOURCE_TEMPLATE_ENTITY_ID = '00000000-0000-0000-0000-000000000001';
const $22b7bc4596013b99$var$newRendererBylineLastUpdatedStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.negative.025',
    marginLeft: 'space.negative.050',
    marginRight: 'space.negative.075'
});
const $22b7bc4596013b99$var$NewRendererByline = (t0)=>{
    const $ = (0, $frIzR.c)(33);
    const { showByLineContributors: showByLineContributors, isTitleCenterAligned: isTitleCenterAligned, version: version, contentId: contentId, showByLineExtensions: showByLineExtensions, isExternalShareRequest: isExternalShareRequest, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, contentSubType: contentSubType, spaceId: spaceId, owner: owner, author: author, isFabricPage: isFabricPage, isOwnerContributor: isOwnerContributor, contributorsCount: contributorsCount, generatedBy: generatedBy, isCurrentUserContributor: isCurrentUserContributor } = t0;
    const { isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const bylineContainerRef = (0, $42omo.useRef)(null);
    let t1;
    if ($[0] !== author || $[1] !== contentId || $[2] !== contributorsCount || $[3] !== generatedBy || $[4] !== isFabricPage || $[5] !== isOwnerContributor || $[6] !== owner || $[7] !== showByLineContributors || $[8] !== version) {
        t1 = showByLineContributors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
            owner: owner,
            author: author,
            analyticsSource: "renderer",
            contributorCountWithoutOwner: contributorsCount - (isOwnerContributor ? 1 : 0),
            generatedBy: generatedBy
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aKxcs.BylineClassification), {
            contentId: contentId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63EIj.RendererContentState), {
            contentId: contentId,
            isDraft: false,
            hasSeparator: false
        }), (!isFabricPage && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") || !(0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $22b7bc4596013b99$var$newRendererBylineLastUpdatedStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $AavAW.ByLineLastUpdatedCompact), {
            version: version
        })));
        $[0] = author;
        $[1] = contentId;
        $[2] = contributorsCount;
        $[3] = generatedBy;
        $[4] = isFabricPage;
        $[5] = isOwnerContributor;
        $[6] = owner;
        $[7] = showByLineContributors;
        $[8] = version;
        $[9] = t1;
    } else t1 = $[9];
    let t2;
    if ($[10] !== author || $[11] !== contentId || $[12] !== contentSubType || $[13] !== contentType || $[14] !== isAIEarlyAccessEnabled || $[15] !== isAdminHubAIEnabled || $[16] !== isCurrentUserContributor || $[17] !== isExternalShareRequest || $[18] !== shouldShowBylineReactions || $[19] !== showByLineExtensions || $[20] !== spaceId) {
        t2 = showByLineExtensions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04VgG.ReadTime), {
            contentId: contentId
        }), isAdminHubAIEnabled && (!(0, $6mKj3.isExperimentEnabled)("confluence_audio_labs_lozenge") || isAIEarlyAccessEnabled) && (0, $6mKj3.isExperimentEnabled)("confluence_audio_v3") && ((0, $6mKj3.expValEquals)("confluence_ai_consumption_byline", "variant", "press_play") || (0, $6mKj3.expValEquals)("confluence_ai_consumption_byline", "variant", "autoplay")) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a9SX7.ListenByline), {
            contentId: contentId,
            contentType: contentType,
            playImmediately: (0, $6mKj3.expValEquals)("confluence_ai_consumption_byline", "variant", "autoplay")
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fImWv.AnalyticsByLine), {
            contentId: contentId,
            contentAuthorId: author.userId
        }), shouldShowBylineReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bbeff754c7e0bdb$export$c52ae103b3391553), {
            contentId: contentId,
            contentType: contentType,
            spaceId: spaceId,
            contentSubType: contentSubType,
            noFlexWrap: true,
            noRelativeContainer: true,
            bylineContainerRef: bylineContainerRef,
            isCurrentUserContributor: isCurrentUserContributor
        }), !isExternalShareRequest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3f1a98366675b36$export$bffecd160d81d78c), null));
        $[10] = author;
        $[11] = contentId;
        $[12] = contentSubType;
        $[13] = contentType;
        $[14] = isAIEarlyAccessEnabled;
        $[15] = isAdminHubAIEnabled;
        $[16] = isCurrentUserContributor;
        $[17] = isExternalShareRequest;
        $[18] = shouldShowBylineReactions;
        $[19] = showByLineExtensions;
        $[20] = spaceId;
        $[21] = t2;
    } else t2 = $[21];
    let t3;
    if ($[22] !== t1 || $[23] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[22] = t1;
        $[23] = t2;
        $[24] = t3;
    } else t3 = $[24];
    const commonContent = t3;
    let t4;
    if ($[25] !== commonContent || $[26] !== contentId || $[27] !== isTitleCenterAligned || $[28] !== showByLineExtensions) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35Exc.StyledTextDiv), {
            hasBadgeStylePageOwnerBylineItem: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iOCg.SingleLineByLine), {
            contentId: contentId,
            isTitleCenterAlignedOverride: isTitleCenterAligned,
            showByLineExtensions: showByLineExtensions
        }, commonContent));
        $[25] = commonContent;
        $[26] = contentId;
        $[27] = isTitleCenterAligned;
        $[28] = showByLineExtensions;
        $[29] = t4;
    } else t4 = $[29];
    let t5;
    if ($[30] !== isTitleCenterAligned || $[31] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35Exc.StyledMainDiv), {
            className: "page-metadata-modification-info",
            isTitleCenterAligned: isTitleCenterAligned,
            ref: bylineContainerRef
        }, t4);
        $[30] = isTitleCenterAligned;
        $[31] = t4;
        $[32] = t5;
    } else t5 = $[32];
    return t5;
};
const $22b7bc4596013b99$var$DefaultRendererByline = (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { showByLineContributors: showByLineContributors, isTitleCenterAligned: isTitleCenterAligned, renderAvatarGroup: renderAvatarGroup, CreatorOrOwnerByline: CreatorOrOwnerByline, version: version, author: author, contentId: contentId, versionComment: versionComment, showByLineExtensions: showByLineExtensions, isExternalShareRequest: isExternalShareRequest } = t0;
    const t1 = showByLineContributors && !isTitleCenterAligned && renderAvatarGroup;
    let t2;
    if ($[0] !== CreatorOrOwnerByline || $[1] !== isTitleCenterAligned || $[2] !== renderAvatarGroup || $[3] !== showByLineContributors) {
        t2 = showByLineContributors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35Exc.StyledAuthorDiv), {
            isTitleCenterAligned: isTitleCenterAligned
        }, isTitleCenterAligned && renderAvatarGroup, CreatorOrOwnerByline);
        $[0] = CreatorOrOwnerByline;
        $[1] = isTitleCenterAligned;
        $[2] = renderAvatarGroup;
        $[3] = showByLineContributors;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== author || $[6] !== contentId || $[7] !== showByLineContributors || $[8] !== version || $[9] !== versionComment) {
        t3 = showByLineContributors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab650b242e9af49c$export$ec2ac95332ccc886), {
            version: version,
            author: author,
            contentId: contentId,
            versionComment: versionComment
        });
        $[5] = author;
        $[6] = contentId;
        $[7] = showByLineContributors;
        $[8] = version;
        $[9] = versionComment;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== author || $[12] !== contentId || $[13] !== isExternalShareRequest || $[14] !== showByLineExtensions) {
        t4 = showByLineExtensions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04VgG.ReadTime), {
            contentId: contentId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fImWv.AnalyticsByLine), {
            contentId: contentId,
            contentAuthorId: author.userId
        }), !isExternalShareRequest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8e28168c9ada36e1$export$2902d9bfb1a677be), {
            contentId: contentId
        })), !isExternalShareRequest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3f1a98366675b36$export$bffecd160d81d78c), null));
        $[11] = author;
        $[12] = contentId;
        $[13] = isExternalShareRequest;
        $[14] = showByLineExtensions;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== t3 || $[17] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, t3, t4);
        $[16] = t3;
        $[17] = t4;
        $[18] = t5;
    } else t5 = $[18];
    let t6;
    if ($[19] !== t2 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35Exc.StyledTextDiv), null, t2, t5);
        $[19] = t2;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.VIEW_PAGE_BYLINE_EXPERIENCE)
        });
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== isTitleCenterAligned || $[24] !== t1 || $[25] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35Exc.StyledMainDiv), {
            className: "page-metadata-modification-info",
            "data-testid": "page-main-div",
            isTitleCenterAligned: isTitleCenterAligned
        }, t1, t6, t7);
        $[23] = isTitleCenterAligned;
        $[24] = t1;
        $[25] = t6;
        $[26] = t8;
    } else t8 = $[26];
    return t8;
};
const $22b7bc4596013b99$export$773979b66159aa2 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(69);
    const { contentId: contentId, author: author, owner: owner, createdDate: createdDate, version: version, versionComment: versionComment, contributors: contributors, contributorsCount: contributorsCount, isOwnerContributor: isOwnerContributor, fetchAllContributors: fetchAllContributors, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, templateId: templateId, isFabricPage: isFabricPage, lastOwner: lastOwner, titleContentProperties: titleContentProperties, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, contentSubType: contentSubType, spaceId: spaceId, generatedBy: generatedBy, isCurrentUserContributor: isCurrentUserContributor } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isExternalShareRequest: isExternalShareRequest } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const lastModifier = version.by;
    let t1;
    if ($[0] !== author || $[1] !== contributors || $[2] !== contributorsCount || $[3] !== lastModifier || $[4] !== owner) {
        const arrangedContributors = (0, $83fWZ.getArrangedContributors)({
            owner: owner,
            author: author,
            lastModifier: lastModifier,
            contributors: contributors
        });
        const userToAvatarGroupDataItem = $22b7bc4596013b99$var$_temp;
        t1 = [
            ...arrangedContributors.map(userToAvatarGroupDataItem),
            ...Array(Math.max(contributorsCount - arrangedContributors.length, 0)).fill(null).map($22b7bc4596013b99$var$_temp2)
        ];
        $[0] = author;
        $[1] = contributors;
        $[2] = contributorsCount;
        $[3] = lastModifier;
        $[4] = owner;
        $[5] = t1;
    } else t1 = $[5];
    const getContributorsData = t1;
    let t2;
    if ($[6] !== contributors || $[7] !== contributorsCount || $[8] !== createAnalyticsEvent || $[9] !== fetchAllContributors) {
        t2 = ()=>{
            if (contributorsCount === contributors.length) return;
            if (!fetchAllContributors) return;
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "dataPrefetched",
                    actionSubject: "moreButton",
                    source: "bylineContributors"
                }
            }).fire();
            fetchAllContributors();
        };
        $[6] = contributors;
        $[7] = contributorsCount;
        $[8] = createAnalyticsEvent;
        $[9] = fetchAllContributors;
        $[10] = t2;
    } else t2 = $[10];
    const allContributorsMayBeNeeded = t2;
    let t3;
    if ($[11] !== contributors || $[12] !== contributorsCount || $[13] !== createAnalyticsEvent || $[14] !== fetchAllContributors) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "dataNeeded",
                    actionSubject: "moreButton",
                    source: "bylineContributors"
                }
            }).fire();
            if (contributorsCount === contributors.length) return;
            if (!fetchAllContributors) return;
            fetchAllContributors();
        };
        $[11] = contributors;
        $[12] = contributorsCount;
        $[13] = createAnalyticsEvent;
        $[14] = fetchAllContributors;
        $[15] = t3;
    } else t3 = $[15];
    const allContributorsAreNeeded = t3;
    let t4;
    if ($[16] !== allContributorsAreNeeded || $[17] !== allContributorsMayBeNeeded) {
        t4 = {
            onMouseEnter: allContributorsMayBeNeeded,
            onClick: allContributorsAreNeeded
        };
        $[16] = allContributorsAreNeeded;
        $[17] = allContributorsMayBeNeeded;
        $[18] = t4;
    } else t4 = $[18];
    const showMoreButtonProps = t4;
    const isBlogPost = templateId === $22b7bc4596013b99$var$BLOG_POST_SOURCE_TEMPLATE_ENTITY_ID;
    const showByLinePoweredByTemplates = Boolean(!isExternalShareRequest && isFabricPage && !isBlogPost && templateId);
    const showByLineContributors = hasByLineContributors ?? true;
    const showByLineExtensions = hasByLineExtensions ?? true;
    let t5;
    if (owner !== null) {
        const t6 = showByLinePoweredByTemplates ? templateId : null;
        let t7;
        if ($[19] !== author || $[20] !== contentId || $[21] !== createdDate || $[22] !== generatedBy || $[23] !== lastOwner || $[24] !== owner || $[25] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3e1c24b20a2bb195$export$6abd4474c72537a), {
                owner: owner,
                creator: author,
                createdDate: createdDate,
                templateId: t6,
                contentId: contentId,
                lastOwner: lastOwner,
                generatedBy: generatedBy
            });
            $[19] = author;
            $[20] = contentId;
            $[21] = createdDate;
            $[22] = generatedBy;
            $[23] = lastOwner;
            $[24] = owner;
            $[25] = t6;
            $[26] = t7;
        } else t7 = $[26];
        t5 = t7;
    } else {
        let t6;
        if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                textDecorationColor: "var(--ds-link, #1868DB)"
            };
            $[27] = t6;
        } else t6 = $[27];
        let t7;
        if ($[28] !== author.fullName || $[29] !== author.isAnonymous || $[30] !== author.userId) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
                userId: author.userId,
                fullName: author.fullName,
                isAnonymous: author.isAnonymous,
                referralSource: "profilecard",
                style: t6
            });
            $[28] = author.fullName;
            $[29] = author.isAnonymous;
            $[30] = author.userId;
            $[31] = t7;
        } else t7 = $[31];
        const linkOnly = t7;
        let t8;
        if ($[32] !== author.fullName || $[33] !== author.userId || $[34] !== linkOnly) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                userId: author.userId,
                fullName: author.fullName
            }, linkOnly);
            $[32] = author.fullName;
            $[33] = author.userId;
            $[34] = linkOnly;
            $[35] = t8;
        } else t8 = $[35];
        const profileLink = t8;
        let t9;
        if ($[36] !== generatedBy || $[37] !== profileLink || $[38] !== showByLinePoweredByTemplates || $[39] !== templateId) {
            t9 = generatedBy === "ONBOARDING" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "content-header.by-line.created.by.expanded.created-by-confluence",
                defaultMessage: "{showByLinePoweredByTemplates, select, true {Created by {author}, created by Confluence, {withTemplate}} false {Created by {author}, created by Confluence} other {Created by {author}, created by Confluence}}",
                values: {
                    author: profileLink,
                    withTemplate: showByLinePoweredByTemplates && !!templateId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c66d644eb983f72b$export$a580dab1b138f630), {
                        templateId: templateId
                    }) : "",
                    showByLinePoweredByTemplates: showByLinePoweredByTemplates
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "content-header.by-line.created.by.expanded",
                defaultMessage: "{showByLinePoweredByTemplates, select, true {Created by {author}, {withTemplate}} false {Created by {author}} other {Created by {author}}}",
                values: {
                    author: profileLink,
                    withTemplate: showByLinePoweredByTemplates && !!templateId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c66d644eb983f72b$export$a580dab1b138f630), {
                        templateId: templateId
                    }) : "",
                    showByLinePoweredByTemplates: showByLinePoweredByTemplates
                }
            });
            $[36] = generatedBy;
            $[37] = profileLink;
            $[38] = showByLinePoweredByTemplates;
            $[39] = templateId;
            $[40] = t9;
        } else t9 = $[40];
        t5 = t9;
    }
    const CreatorOrOwnerByline = t5;
    const t6 = isTitleCenterAligned ? "small" : "medium";
    let t7;
    if ($[41] !== getContributorsData || $[42] !== showMoreButtonProps || $[43] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
            appearance: "stack",
            data: getContributorsData,
            avatar: (0, $fs6LW.ProfileAvatar),
            maxCount: $22b7bc4596013b99$var$NO_OF_AVATARS,
            size: t6,
            showMoreButtonProps: showMoreButtonProps,
            testId: "renderer-byline-contributors"
        });
        $[41] = getContributorsData;
        $[42] = showMoreButtonProps;
        $[43] = t6;
        $[44] = t7;
    } else t7 = $[44];
    let t8;
    if ($[45] !== isTitleCenterAligned || $[46] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35Exc.StyledAvatars), {
            isTitleCenterAligned: isTitleCenterAligned
        }, t7);
        $[45] = isTitleCenterAligned;
        $[46] = t7;
        $[47] = t8;
    } else t8 = $[47];
    const renderAvatarGroup = t8;
    let t9;
    if ($[48] !== CreatorOrOwnerByline || $[49] !== author || $[50] !== contentId || $[51] !== contentSubType || $[52] !== contentType || $[53] !== contributorsCount || $[54] !== generatedBy || $[55] !== isCurrentUserContributor || $[56] !== isExternalShareRequest || $[57] !== isFabricPage || $[58] !== isOwnerContributor || $[59] !== isTitleCenterAligned || $[60] !== owner || $[61] !== renderAvatarGroup || $[62] !== shouldShowBylineReactions || $[63] !== showByLineContributors || $[64] !== showByLineExtensions || $[65] !== spaceId || $[66] !== version || $[67] !== versionComment) {
        t9 = (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($22b7bc4596013b99$var$NewRendererByline, {
            contentId: contentId,
            version: version,
            showByLineContributors: showByLineContributors,
            showByLineExtensions: showByLineExtensions,
            isExternalShareRequest: isExternalShareRequest,
            isTitleCenterAligned: isTitleCenterAligned,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentType: contentType,
            contentSubType: contentSubType,
            spaceId: spaceId,
            owner: owner,
            author: author,
            isFabricPage: isFabricPage,
            isOwnerContributor: isOwnerContributor,
            contributorsCount: contributorsCount,
            generatedBy: generatedBy,
            isCurrentUserContributor: isCurrentUserContributor
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($22b7bc4596013b99$var$DefaultRendererByline, {
            contentId: contentId,
            author: author,
            version: version,
            versionComment: versionComment,
            showByLineContributors: showByLineContributors,
            showByLineExtensions: showByLineExtensions,
            isExternalShareRequest: isExternalShareRequest,
            isTitleCenterAligned: isTitleCenterAligned,
            renderAvatarGroup: renderAvatarGroup,
            CreatorOrOwnerByline: CreatorOrOwnerByline
        });
        $[48] = CreatorOrOwnerByline;
        $[49] = author;
        $[50] = contentId;
        $[51] = contentSubType;
        $[52] = contentType;
        $[53] = contributorsCount;
        $[54] = generatedBy;
        $[55] = isCurrentUserContributor;
        $[56] = isExternalShareRequest;
        $[57] = isFabricPage;
        $[58] = isOwnerContributor;
        $[59] = isTitleCenterAligned;
        $[60] = owner;
        $[61] = renderAvatarGroup;
        $[62] = shouldShowBylineReactions;
        $[63] = showByLineContributors;
        $[64] = showByLineExtensions;
        $[65] = spaceId;
        $[66] = version;
        $[67] = versionComment;
        $[68] = t9;
    } else t9 = $[68];
    return t9;
});
function $22b7bc4596013b99$var$_temp(user) {
    return {
        isAnonymous: user.isAnonymous,
        userId: user.userId,
        src: user.avatarUrl,
        name: user.fullName
    };
}
function $22b7bc4596013b99$var$_temp2() {
    return {
        src: (0, $af34c07ddecde08d$export$1ee11f8c529fc453),
        name: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35Exc.StyledNameSkeleton), null)
    };
}


/**
 * @generated SignedSource<<387b3b5a19d8bd1cc0355c392ec5e036>>
 * @relayHash 80f146a83f48be7b9331f291c6222df0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962
const $cb80c8184222fcac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v9 = {
        "kind": "ScalarField",
        "name": "number"
    }, v10 = {
        "kind": "ScalarField",
        "name": "confRev"
    }, v11 = {
        "kind": "ScalarField",
        "name": "syncRev"
    }, v12 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "80f146a83f48be7b9331f291c6222df0",
            "id": "441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962",
            "metadata": {},
            "name": "ExternalByLineQuery",
            "operationKind": "query",
            "text": "query ExternalByLineQuery($contentId:ID!){singleContent(id:$contentId){id,type,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId}},ownedBy{__typename,type,displayName,...on KnownUser{accountId}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,confRev,syncRev,contentTypeModified}}}"
        }
    };
}();
$cb80c8184222fcac$var$node.hash = "012bf9a7497572d73e22134c755e8758";
var $cb80c8184222fcac$export$2e2bcd8739ae039 = $cb80c8184222fcac$var$node;


const $3ade7df4fa86d9cd$export$83e33e2cb03d444b = (0, $cb80c8184222fcac$export$2e2bcd8739ae039);


// WARN: This is temporary code to send analytics event when we would crash the part
// of the ByLine experience when byline user is undefined due to any reason.
// This is done as part of https://ops.internal.atlassian.com/jira/browse/HOT-106424
// investigation. This code should be removed once we know the root cause/impact.
const $0559514361f7ee96$var$HOT106424Tracker = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { content: content, contentId: contentId, contentContributors: contentContributors, isExternalShareRequest: isExternalShareRequest } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== content || $[1] !== contentContributors?.nodes || $[2] !== contentId || $[3] !== createAnalyticsEvent || $[4] !== isExternalShareRequest) {
        t1 = ()=>{
            const byUser = content?.version?.by;
            const createdBy = content?.history?.createdBy;
            const hasEmptyContributors = (contentContributors?.nodes || []).some($0559514361f7ee96$var$_temp);
            const history = content?.history;
            const createdDate = content?.history?.createdDate;
            if (hasEmptyContributors || !createdBy || !byUser) createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    source: "byLine",
                    action: "byLineUserEmpty",
                    actionSubject: "content",
                    attributes: {
                        contentId: contentId,
                        isExternalShareRequest: isExternalShareRequest,
                        hasEmptyContributors: hasEmptyContributors,
                        hasCreatedBy: Boolean(createdBy),
                        hasByUser: Boolean(byUser),
                        hasContent: Boolean(content),
                        hasHistory: Boolean(history),
                        hasCreatedDate: Boolean(createdDate)
                    }
                }
            }).fire();
        };
        $[0] = content;
        $[1] = contentContributors?.nodes;
        $[2] = contentId;
        $[3] = createAnalyticsEvent;
        $[4] = isExternalShareRequest;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== content || $[7] !== contentContributors || $[8] !== contentId || $[9] !== createAnalyticsEvent || $[10] !== isExternalShareRequest) {
        t2 = [
            content,
            contentId,
            contentContributors,
            createAnalyticsEvent,
            isExternalShareRequest
        ];
        $[6] = content;
        $[7] = contentContributors;
        $[8] = contentId;
        $[9] = createAnalyticsEvent;
        $[10] = isExternalShareRequest;
        $[11] = t2;
    } else t2 = $[11];
    (0, $42omo.useEffect)(t1, t2);
    return null;
};
const $0559514361f7ee96$export$3b7993d3cbe5f289 = ({ contentId: contentId, versionOverride: versionOverride, embeddedContentRender: embeddedContentRender, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, spaceId: spaceId, contentSubType: contentSubType, ...passThroughProps })=>{
    /**
   * Initially, only request enough contributors to populate displayed
   * avatars of the ByLineWithContributorsComponent's AvatarGroup.
   * This is four at most; at five it shows three and a '+2' button.
   * Additional contributors will be requested on-demand when hovering
   * over/clicking its '+2' (or whatever) button.
   *
   * Additional Note: Please update the default limit in the relevant query to match
   * DEFAULT_CONTRIBUTORS_FETCH_LIMIT. Preloader will not work as expected if these
   * limits do not match.
   */ const [contributorsFetchLimit, setContributorsFetchLimit] = (0, $42omo.useState)((0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isExternalShareRequest: isExternalShareRequest } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const lastLoadedQueryData = (0, $42omo.useRef)(null);
    const fetchAllContributors = ()=>{
        if (lastLoadedQueryData.current) // The lastLoadedQueryData would be from the initial request with the
        // fetch limit of 4
        setContributorsFetchLimit(lastLoadedQueryData.current?.contentContributors?.count || Number.MAX_SAFE_INTEGER);
    };
    // eslint-disable-next-line prefer-const
    let { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)(isExternalShareRequest ? (0, $3ade7df4fa86d9cd$export$83e33e2cb03d444b) : (0, $fxLAA.default), {
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // Don't omit versionOverride, embeddedContentRender and limit
            // It's an Apollo bug that if preloader these needs to be match preloaded query
            // Also doesn't work if removing them from preloader variables HOT-109035
            versionOverride: versionOverride || null,
            embeddedContentRender: embeddedContentRender || null,
            limit: contributorsFetchLimit,
            useNewContentTopper: true
        },
        context: {
            allowOnExternalPage: true,
            single: true
        }
    });
    const reload = (0, $42omo.useCallback)(// Forcing refetch by passing dummy variable. Known Apollo bug (ノಠ益ಠ)ノ彡┻━┻, see page below:
    // https://pug.jira-dev.com/wiki/spaces/~683304838/pages/5971970200/Apollo+Client+-+weird+refetch+behavior
    // Reason using static cacheBuster: "":
    // ContentTitle component also makes ContentHeaderUnifiedQuery and refetch.
    // If using different cache buster values, the refetch in each component will make its owen refetch network call.
    // So setting a static value for this and ContentTitle component to make refetch network call only once.
    // And a static cache buster value can also force refetch to ignore cache of original query.
    ()=>refetch({
            contentId: contentId,
            cacheBuster: ''
        }), [
        refetch,
        contentId
    ]);
    (0, $1SNEF.useQuickReloadSubscriber)({
        name: 'byline',
        types: [
            (0, $c0urc.ReloadType).content
        ],
        reload: reload
    });
    const renderByLine = ()=>{
        if (loading) {
            // If we're loading because the ByLineWithContributorsComponent called our
            // fetchAllContributors, then we should continue the render with data
            // cached from the previous query (the one with the low
            // contributorsFetchLimit). It's important to not bring the skeletons back
            // up, as that'd kill the opening of the dropdown.
            if (lastLoadedQueryData.current) data = lastLoadedQueryData.current;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1d8e46f2fc87fe7$export$438daec06afefb9e), null);
        } else if (!error) lastLoadedQueryData.current = data || null;
        const content = isExternalShareRequest ? data?.singleContent : data?.content?.nodes?.[0];
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return null;
            } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
            // so returning empty `<ErrorDisplay>` here.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
        } else if (!content) return null;
        const author = (0, $83fWZ.toUserProps)(content?.history?.createdBy);
        const owner = content?.history?.ownedBy && content?.type === 'page' ? (0, $83fWZ.toUserProps)(content?.history?.ownedBy) : null;
        const lastOwner = content?.history?.lastOwnedBy && content?.type === 'page' ? (0, $83fWZ.toUserProps)(content?.history?.lastOwnedBy) : null;
        const createdDateString = content?.history?.createdDate;
        const createdDate = createdDateString ? new Date(createdDateString) : null;
        const by = (0, $83fWZ.toUserProps)(content?.version?.by);
        // @ts-expect-error -- `ExternalByLineQuery` does not query for version messages; this should later be refactored to Relay fragments in the actual components
        const versionComment = content?.version?.message || undefined;
        const contributors = data?.contentContributors?.nodes?.map((0, $83fWZ.toUserProps)) || [];
        const contributorsCount = data?.contentContributors?.count || 0;
        const isOwnerContributor = data?.contentContributors?.isOwnerContributor || false;
        const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor || false;
        const templateId = !isExternalShareRequest ? (0, $83fWZ.getSourceTemplateKey)(data) : null;
        const isFabricPage = !isExternalShareRequest ? (0, $83fWZ.isFabricEditor)(data) : false;
        const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(data);
        const generatedBy = !isExternalShareRequest ? content?.contentProperties?.latest?.generatedBy : undefined;
        const componentProps = {
            contentId: contentId,
            author: author,
            owner: owner,
            createdDate: createdDate,
            contributors: contributors,
            contributorsCount: contributorsCount,
            isOwnerContributor: isOwnerContributor,
            versionComment: versionComment,
            fetchAllContributors: fetchAllContributors,
            templateId: templateId,
            isFabricPage: isFabricPage,
            lastOwner: lastOwner,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentSubType: contentSubType,
            spaceId: spaceId,
            contentType: contentType,
            titleContentProperties: titleContentProperties,
            generatedBy: generatedBy,
            version: {
                friendlyWhen: content?.version?.friendlyWhen || '',
                number: Number(content?.version?.number || ''),
                by: by,
                // @ts-expect-error -- `ContentHeaderUnifiedQuery` does not query for `syncRev`; this should later be refactored to Relay fragments in the actual components
                syncRev: content?.version?.syncRev || 0,
                // @ts-expect-error -- `ContentHeaderUnifiedQuery` does not query for `confRev`; this should later be refactored to Relay fragments in the actual components
                confRev: content?.version?.confRev || 0,
                contentTypeModified: content?.version?.contentTypeModified || false
            },
            isCurrentUserContributor: isCurrentUserContributor,
            ...passThroughProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $22b7bc4596013b99$export$773979b66159aa2), componentProps), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC),
            customData: {
                contributorsCount: contributorsCount
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0559514361f7ee96$var$HOT106424Tracker, {
            content: content,
            contentId: contentId,
            contentContributors: data?.contentContributors,
            isExternalShareRequest: isExternalShareRequest
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.VIEW_PAGE_BYLINE_EXPERIENCE),
        id: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        key: contentId,
        metric: (0, $hlP5l.BYLINE_METRIC)
    }), renderByLine());
};
function $0559514361f7ee96$var$_temp(node) {
    return !node;
}
module.exports["ByLine"] = $0559514361f7ee96$export$3b7993d3cbe5f289;

});


//# sourceMappingURL=ExternalSharePage.5015143e.js.map
